import { render, staticRenderFns } from "./StructureCol.vue?vue&type=template&id=68b9d8fd&scoped=true&"
import script from "./StructureCol.vue?vue&type=script&lang=js&"
export * from "./StructureCol.vue?vue&type=script&lang=js&"
import style0 from "./StructureCol.vue?vue&type=style&index=0&id=68b9d8fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9d8fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VIcon})
